import styled from 'styled-components';

export const StyledGroupFollowerGains = styled.span`
    display: flex;
    align-items: center;
    -webkit-font-smoothing: antialiased;
    background: rgba(61, 241, 165, 0.35);
    color: white;
    padding: 2px 6px;
    gap: 10px;
    border-radius: 12px;
    height: 20px;

    font-family: 'Alliance No.1';
    font-style: normal;
    font-weight: 700;

    text-align: right;
    white-space: nowrap;

    color: #ffffff;

    font-size: 10px;
    line-height: 13px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 12px;
        line-height: 16px;
    }
`;
